/**
 * Utility functions for need-related operations
 */

/**
 * Check if a need is considered "fresh" (created within the last 7 days)
 * @param {string|null|undefined} createdAt - ISO date string of when the need was created
 * @returns {boolean} - true if the need was created within the last 7 days (168 hours)
 */
export const isFreshNeed = (createdAt) => {
  if (!createdAt) {
    return false;
  }

  try {
    const createdDate = new Date(createdAt);
    const now = new Date();
    const daysSinceCreation = Math.floor((now - createdDate) / (1000 * 60 * 60 * 24));
    
    // Need is considered "fresh" if created within last 7 days
    return daysSinceCreation < 7;
  } catch (error) {
    console.error('Error parsing createdAt date:', error);
    return false;
  }
};



